<template>
  <div>
    <v-dialog v-model="dialog" 
      persistent
      width="500">
      <v-card class="border-radius box-shadow">
        <v-card-text class="text-second pa-5 px-7">
          Apakah anda yakin mengkonfimasi {{ all ? 'semua pembayaran' : 'pembayaran' }} <b v-if="!all">{{ detail.cash_tempo_label }}</b> ?
        </v-card-text>
        <v-card-text>
          <quill-editor 
            ref="myTextEditor"
            :options="option"
            v-model="detail.cash_tempo_desc">
          </quill-editor>
        </v-card-text>
        <v-divider class="mx-4 my-2"/>
        <v-card-actions class="pa-5">
          <v-spacer/>
          <v-btn
            outlined
            :color="style.primary"
            class="text-capitalize green--text mx-1"
            :disabled="process.form"
            :loading="process.form"
            @click="confirmation">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Simpan
          </v-btn>
          <v-btn
            outlined
            color="red"
            class="text-capitalize red--text mx-1"
            :disabled="process.form"
            @click="dialog = false; all = false; detail = {};">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-row>
      <v-col cols="12" class="py-0">
        <v-card
          style="border-radius: 0px;"
          flat>
          <div style="background: var(--color-primary)">
            <v-card-title class="subtitle-2 white--text">
              Pembayaran
            </v-card-title>
            <v-card-subtitle class="white--text line-text-first pt-2 caption">
              Anda bisa membuat / menambahkan cash tempo (down payment). Lalu tekan tombol simpan pembayaran.
            </v-card-subtitle>
          </div>
          <div v-if="add">
            <v-card-text>
              <v-alert
                outlined text
                type="info"
                color="orange"
                class="caption">
                Anda belum melakukan pengaturan (men-set) skema pembayaran (atau DP)
              </v-alert>
            </v-card-text>
            <v-card-text class="py-0">
              <ValidationObserver ref="observer">
                <v-form class="pr-1 pb-0">
                  <v-row>
                    <v-col cols="12" md="5" class="py-0">
                      <ValidationProvider name="Jumlah Pembayaran" rules="required" v-slot="{ errors }">
                        <v-currency-field 
                          dense
                          outlined
                          label="Jumlah Pembayaran"
                          :color="style.primary"
                          prepend-inner-icon="mdi-cash-100"
                          v-model="form.total_price"
                          :error-messages="errors"
                          require>
                        </v-currency-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" md="4" class="py-0">
                      <ValidationProvider name="Angsuran" rules="required" v-slot="{ errors }">
                        <v-text-field
                          type="number"
                          dense
                          outlined
                          label="Jumlah Angsuran"
                          :color="style.primary"
                          prepend-inner-icon="mdi-numeric"
                          v-model="form.count"
                          :error-messages="errors"
                          require>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" md="3" class="py-0">
                      <v-btn
                        outlined
                        height="40"
                        color="orange"
                        class="text-capitalize orange--text"
                        :disabled="process.run"
                        :loading="process.run"
                        @click="downPayment">
                        <v-icon class="mr-1">
                          {{ form.dp.length > 0 ? 'mdi-reload' : 'mdi-cash-plus' }}
                        </v-icon>
                        {{ form.dp.length > 0 ? 'Hitung Ulang' : 'Buat Biaya' }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </ValidationObserver>
            </v-card-text>
            <v-card-text class="font-italic text-third py-0 caption" v-if="form.dp.length > 0">
              #note : Jika anda mengubah "Jumlah Pembayaran" / "Jumlah Angsuran", silahkan klik tombol <b class="text-second">Hitung Ulang</b>.
            </v-card-text>
            <p class="mx-4 mt-5 red--text caption d-flex align-center" v-if="error.message.length > 0">
              <v-icon small color="red" class="mr-1">mdi-alert-circle-outline</v-icon>
              <span v-html="error.message"></span>
            </p>
            <v-card-text v-if="form.dp.length > 0">
              <v-btn
                small
                outlined
                color="green"
                class="text-capitalize mr-2"
                @click="addDP()">
                Tambahkan Pembayaran
              </v-btn>
              <!-- <v-btn
                small
                outlined
                color="red"
                class="text-capitalize"
                @click="reset()">
                Hapus Semua
              </v-btn> -->
              <v-divider class="mt-5 mb-2"/>
              <v-row
                v-for="(item, index) in form.dp"
                :key="index">
                <v-col cols="1">
                  <div style="width: 32px;">
                    <v-chip
                      class="px-0 d-flex justify-center align-center"
                      style="width: 100px; border-radius: 0px !important;"
                      label>
                      {{ index+1 }}
                    </v-chip>
                    <v-chip
                      style="border-radius: 0px !important;"
                      label
                      color="red"
                      class="px-1 text-center cursor-pointer"
                      :disabled="!item.editable"
                      @click="removeDP(index, item.id)">
                      <v-icon color="white">mdi-close</v-icon>
                    </v-chip>
                  </div>
                </v-col>
                <v-col cols="11">
                  <v-row>
                    <v-col cols="12" class="py-0">
                      <v-text-field
                        dense
                        outlined
                        label="Jenis Pembayaran"
                        :color="style.primary"
                        prepend-inner-icon="mdi-clock-check-outline"
                        disabled
                        v-model="item.type">
                      </v-text-field>
                    </v-col>
                    <v-col cols="6" class="py-0">
                      <v-currency-field 
                        dense
                        outlined
                        label="Jumlah Pembayaran"
                        :color="style.primary"
                        prepend-inner-icon="mdi-cash-100"
                        :disabled="!item.editable"
                        v-model="item.price"
                        @blur="recount(index)">
                      </v-currency-field>
                    </v-col>
                    <v-col cols="6" class="py-0">
                      <v-select
                        dense
                        outlined
                        label="Status"
                        :color="style.primary"
                        hide-details
                        prepend-inner-icon="mdi-cash-check"
                        :items="!item.editable ? [
                          {
                            label: 'Belum Bayar',
                            value: 'open',
                            disable: false
                          },
                          {
                            label: 'Menunggu Konfirmasi Finance',
                            value: 'confirmed',
                            disable: false
                          },
                          {
                            label: 'Sudah Bayar',
                            value: 'close',
                            disable: true
                          }
                        ] : [
                          {
                            label: 'Belum Bayar',
                            value: 'open',
                            disable: false
                          },
                          {
                            label: 'Menunggu Konfirmasi Finance',
                            value: 'confirmed',
                            disable: false
                          }
                        ]"
                        item-disabled="disable"
                        item-text="label"
                        item-value="value"
                        item-color="light-green lighten-2"
                        :disabled="!item.editable"
                        v-model="item.status"
                        v-on:change="item.paydate = ''">
                        <template v-slot:append>
                          <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="6" class="py-0">
                      <v-menu
                        ref="tempo"
                        min-width="290px"
                        max-width="290px"
                        transition="scale-transition"
                        offset-y
                        :nudge-right="40"
                        :close-on-content-click="false"
                        v-model="item.picker.tempo">
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            dense
                            outlined
                            readonly
                            :color="style.primary"
                            prepend-inner-icon="mdi-calendar-month"
                            label="Jatuh Tempo"
                            :disabled="!item.editable"
                            v-model="item.duedate"
                            v-on="on">
                          </v-text-field>
                        </template>
                        <v-date-picker 
                          :color="style.primary"
                          v-model="item.duedate"
                          @input="item.picker.tempo = false">
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="6" class="py-0">
                      <v-menu
                        ref="pay"
                        min-width="290px"
                        max-width="290px"
                        transition="scale-transition"
                        offset-y
                        :nudge-right="40"
                        :close-on-content-click="false"
                        v-model="item.picker.pay">
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            dense
                            outlined
                            readonly
                            :color="style.primary"
                            prepend-inner-icon="mdi-calendar-month"
                            label="Tanggal Bayar"
                            :disabled="item.status === 'open' || !item.editable"
                            v-model="item.paydate"
                            v-on="on">
                          </v-text-field>
                        </template>
                        <v-date-picker 
                          :color="style.primary"
                          v-model="item.paydate"
                          @input="item.picker.pay = false">
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <quill-editor 
                    ref="myTextEditor"
                    :options="option"
                    v-model="item.desc">
                  </quill-editor>
                </v-col>
              </v-row>
              <p class="red--text">
                <span v-if="calculate().totalDP() > parseInt(form.total_price)">
                  *DP melebihi jumlah pembayaran
                </span>
                <span v-if="calculate().totalDP() < parseInt(form.total_price)">
                  *DP kurang dari jumlah pembayaran
                </span>
              </p>
              <v-btn
                color="teal"
                class="text-capitalize white--text" id="dp"
                :disabled="process.run || calculate().totalDP() > parseInt(form.total_price) || calculate().totalDP() < parseInt(form.total_price)"
                :loading="process.run"
                @click="save">
                <v-icon small class="mr-1">mdi-check</v-icon>
                Simpan Pembayaran
              </v-btn>
            </v-card-text>
          </div>

          <v-card-text v-if="!add">
            <v-btn v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')"
              small
              outlined
              color="orange"
              class="text-capitalize mr-2"
              @click="add = true; calculate().totalDP();">
              Ubah Down Payment
            </v-btn>
            <v-divider class="mt-5 mb-2" v-if="form.dp.length > 0 && (user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator'))"/>
            <v-skeleton-loader
              class="ma-auto"
              :loading="process.run"
              transition="scale-transition"
              :tile="false"
              type="table">
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr 
                      v-for="(item, index) in process.run ? 7 : list" 
                      :key="index">
                      <td class="text-second pl-0" width="300">
                        {{ item.cash_tempo_label }}
                      </td>
                      <td class="caption text-second">
                        <v-list-item class="pa-0">
                          <v-list-item-content>
                            <v-list-item-title class="caption text-second mb-1">
                              {{ parseInt(item.cash_tempo_value) | price }}
                            </v-list-item-title>
                            <v-list-item-subtitle class="text-third" style="font-size: 10px;">
                              Tempo {{ item.cash_tempo_due_date | date }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </td>
                      <td class="caption text-second text-right pr-0">
                        <!-- JIKA MASIH AKTIF -->
                        <div v-if="booking.company_project_is_active === '1'">
                          <!-- SUPERUSER | ADMINISTRATOR -->
                          <div v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')">
                            <v-list-item class="pa-0" v-if="item.cash_tempo_status !== 'open'">
                              <v-list-item-content>
                                <v-list-item-title class="caption font-weight-bold mb-1"
                                  :class="item.cash_tempo_status === 'confirmed' ? 'color-default' : 'teal--text'">
                                  {{ item.cash_tempo_status === 'confirmed' ? 'Menunggu Konfirmasi Finance' : 'Terbayar' }}
                                </v-list-item-title>
                                <v-list-item-subtitle class="text-third" style="font-size: 10px;">
                                  {{ item.cash_tempo_status === 'confirmed' ? 'Dibayarkan' : 'Pada' }} 
                                  {{ item.cash_tempo_closing_datetime | date }}
                                </v-list-item-subtitle>
                              </v-list-item-content>

                              <v-list-item-action v-if="item.cash_tempo_status === 'close'">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      small
                                      elevation="0"
                                      min-width="25"
                                      height="25"
                                      class="pa-0"
                                      color="teal"
                                      :loading="process.print"
                                      :disabled="process.print"
                                      @click="prints(item.cash_tempo_id)"
                                      v-bind="attrs"
                                      v-on="on">
                                      <v-icon small color="white">mdi-microsoft-excel</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Print</span>
                                </v-tooltip>
                              </v-list-item-action>
                            </v-list-item>
                            <v-btn
                              v-if="item.cash_tempo_status === 'open'"
                              small
                              width="200"
                              outlined
                              :color="style.primary"
                              class="text-capitalize"
                              style="margin: 8px 0px;"
                              @click="dialog = true; detail = item;">
                              <v-icon small class="mr-1">mdi-check</v-icon>
                              Konfirmasi Pembayaran
                            </v-btn>
                          </div>

                          <!-- FINANCE -->
                          <div v-if="user.user_company_roles_name.includes('finance')">
                            <v-list-item class="pa-0" v-if="item.cash_tempo_status === 'open'">
                              <v-list-item-content>
                                <v-list-item-title class="caption font-weight-bold red--text mb-1">
                                  Belum Dibayar
                                </v-list-item-title>
                                <v-list-item-subtitle class="text-third" style="font-size: 10px;">
                                  Jatuh Tempo {{ item.cash_tempo_due_date | date }}
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item class="pa-0" v-if="item.cash_tempo_status === 'close'">
                              <v-list-item-content>
                                <v-list-item-title class="caption font-weight-bold teal--text mb-1">
                                  Terbayar
                                </v-list-item-title>
                                <v-list-item-subtitle class="text-third" style="font-size: 10px;">
                                  Pada {{ item.cash_tempo_closing_datetime | date }}
                                </v-list-item-subtitle>
                              </v-list-item-content>

                              <v-list-item-action v-if="item.cash_tempo_status === 'close'">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      small
                                      elevation="0"
                                      min-width="25"
                                      height="25"
                                      class="pa-0"
                                      color="teal"
                                      :loading="process.print"
                                      :disabled="process.print"
                                      @click="prints(item.cash_tempo_id)"
                                      v-bind="attrs"
                                      v-on="on">
                                      <v-icon small color="white">mdi-microsoft-excel</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Print</span>
                                </v-tooltip>
                              </v-list-item-action>
                            </v-list-item>
                            <v-btn
                              v-if="item.cash_tempo_status === 'confirmed'"
                              small
                              width="200"
                              outlined
                              :color="style.primary"
                              class="text-capitalize"
                              @click="dialog = true; detail = item;">
                              <v-icon small class="mr-1">mdi-check</v-icon>
                              Konfirmasi Pembayaran
                            </v-btn>
                          </div>

                          <!-- SUPERVISOR | MARKETING | DEVELOPER -->
                          <div v-if="!user.user_company_roles_name.includes('superuser') && !user.user_company_roles_name.includes('administrator') && !user.user_company_roles_name.includes('finance')">
                            <v-list-item class="pa-0">
                              <v-list-item-content>
                                <v-list-item-title class="caption font-weight-bold mb-1"
                                  :class="item.cash_tempo_status === 'open' ? 'red--text' : item.cash_tempo_status === 'confirmed' ? 'color-default' : 'teal--text'">
                                  {{ item.cash_tempo_status === 'open' ? 'Belum Dibayar' : item.cash_tempo_status === 'confirmed' ? 'Menunggu Konfirmasi Finance' : 'Terbayar' }}
                                </v-list-item-title>
                                <v-list-item-subtitle class="text-third" style="font-size: 10px;">
                                  {{ item.cash_tempo_status === 'open' ? 'Jatuh Tempo' : item.cash_tempo_status === 'confirmed' ? 'Dibayarkan' : 'Pada' }}
                                  <span v-if="item.cash_tempo_status === 'open'">
                                    {{ item.cash_tempo_due_date | date }}
                                  </span>
                                  <span v-if="item.cash_tempo_status !== 'open'">
                                    {{ item.cash_tempo_closing_datetime | date }}
                                  </span>
                                </v-list-item-subtitle>
                              </v-list-item-content>

                              <v-list-item-action v-if="item.cash_tempo_status === 'close'">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      small
                                      elevation="0"
                                      min-width="25"
                                      height="25"
                                      class="pa-0"
                                      color="teal"
                                      :loading="process.print"
                                      :disabled="process.print"
                                      @click="prints(item.cash_tempo_id)"
                                      v-bind="attrs"
                                      v-on="on">
                                      <v-icon small color="white">mdi-microsoft-excel</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Print</span>
                                </v-tooltip>
                              </v-list-item-action>
                            </v-list-item>
                          </div>
                        </div>

                        <!-- JIKA SUDAH HABIS MASA AKTIF -->
                        <div v-if="booking.company_project_is_active === '0'">
                          <span class="red--text font-weight-bold">
                            Langganan Habis
                          </span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="subtitle-2 text-first pl-0">
                        Total
                      </td>
                      <td class="subtitle-2 text-first">
                        {{ fixedNumber(form.total_price) | price }}
                      </td>
                      <td class="caption text-second text-right pr-0">
                        <!-- SUPERUSER | ADMINISTRATOR -->
                        <div v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')">
                          <v-list-item-content v-if="allPay">
                            <v-list-item-title class="caption font-weight-bold teal--text mb-1">
                              {{ list[list.length - 1].cash_tempo_status === 'confirmed' ? 'Menunggu Konfirmasi Finance' : 'Terbayar' }}
                            </v-list-item-title>
                            <v-list-item-subtitle class="text-third" style="font-size: 10px;">
                              Pada {{ list[list.length - 1].cash_tempo_closing_datetime | date }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-btn
                            small
                            width="200"
                            :color="style.primary"
                            class="text-capitalize white--text"
                            v-if="!allPay"
                            @click="dialog = true; all = true;">
                            <v-icon small class="mr-1">mdi-check-all</v-icon>
                            Konfirmasi Semua
                          </v-btn>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-skeleton-loader>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    
    <v-fab-transition>
      <v-btn
        class="mx-12 mb-8"
        v-scroll="onScroll"
        v-show="fab"
        elevation="3"
        fab
        width="50"
        height="50"
        dark
        fixed
        bottom
        right
        :color="style.primary"
        @click="$vuetify.goTo('#app', {duration: 500, offset: 0})">
        <v-icon>mdi-chevron-up</v-icon>
      </v-btn>
    </v-fab-transition>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../service/Axios";
  import moment from 'moment';
  export default {
    data () {
      return {
        dialog: false,
        fab: false,
        option: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline'],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'align': [] }]
            ]
          },
          placeholder: 'Keterangan'
        },
        add: false,
        all: false,
        allPay: false,
        list: [],
        detail: {},
        form: {
          transaction_id: '',
          total_price: '',
          count: '',
          dp: [],
          delete: []
        },
        process: {
          run: false,
          form: false,
          print: false
        },
        error: {
          message: ''
        },
        style: {
          primary: "#8BC541"
        }
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    watch: {
      
    },
    props: [
      'booking'
    ],
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch(generate) {
        this.process.run = true
        await get(`auth/transaction/cash-tempo/down-payment/detail`, {
          params: {
            transaction_id: this.$route.query.transaction
          }
        })
        .then(response => {
          let res = response.data
          if (res.status == 200) {
            this.process.run = false

            if (generate) {
              this.add = true
            } else {
              this.add = res.data.results.length > 0 ? false : true
            }
            this.list = res.data.results
            
            this.reset()

            res.data.results.forEach(item => {
              this.form.transaction_id = item.cash_tempo_transaction_id
              this.form.total_price = res.data.total_price
              this.form.count = res.data.count
              this.form.dp.push({
                id: item.cash_tempo_id,
                type: item.cash_tempo_label,
                price: parseInt(item.cash_tempo_value),
                duedate: item.cash_tempo_due_date,
                paydate: item.editable ? '' : moment(item.cash_tempo_closing_datetime).format('Y-MM-DD'),
                status: item.cash_tempo_status,
                editable: item.editable,
                desc: item.cash_tempo_desc,
                picker: item.picker
              })
            })

            let total = res.data.results.filter(item => item.cash_tempo_status === 'open')
            this.allPay = total.length > 0 ? false : true
          }
        })
      },
      onScroll (e) {
        if (typeof window === 'undefined') return
        const top = window.pageYOffset || e.target.scrollTop || 0
        this.fab = top > window.innerHeight-100
      },
      async downPayment() {
        this.error.message = ''
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.run = true

          await post(`auth/transaction/cash-tempo/down-payment/generate-down-payment`, {
            data: {
              transaction_id: this.form.transaction_id,
              total_price: this.form.total_price,
              count: this.form.count
            }
          }).then(response => {
            let res = response.data
            if (res.status === 200) {
              this.process.run = false
              this.fetch(true)
            } else {
              this.process.run = false
              this.error.message = res.msg
            }
          })
        }
      },
      reset() {
        this.form = {
          transaction_id: this.$route.query.transaction,
          total_price: '',
          count: '',
          dp: [],
          delete: []
        }
      },
      addDP() {
        this.form.transaction_id = this.$route.query.transaction

        let dividen = this.calculate().dividenAdd()
        let count = this.calculate().countRemove()+1
        let price = this.fixedNumber(dividen / count)

        this.form.dp.push({
          id: 0,
          type: `Down Payment ${count+1}`,
          price: 0,
          duedate: '',
          paydate: '',
          status: 'open',
          editable: true,
          desc: '',
          picker: {
            tempo: false,
            pay: false
          }
        })

        this.form.dp.forEach(function(val, index) {
          if (val.editable) {
            val.price = price
          }
        })

        this.$nextTick(() => {
          this.$vuetify.goTo('#dp', {duration: 500, offset: 500})
        })
      },
      removeDP(index, id) {
        this.form.dp.splice(index, 1)

        let dividen = this.calculate(index).dividenRemove()
        let count = this.calculate(index).countRemove()
        let price = this.fixedNumber((this.form.total_price - dividen) / count)

        this.form.dp.forEach(function(val, index) {
          if (val.editable) {
            let i = index+1
            val.type = `Down Payment ${i}`
            val.price = price
          }
        })
        
        this.form.delete.push(id)

        this.calculate().totalDP()
      },
      recount(idx) {
        let dividen = 0, count = 0, fix = 0

        this.form.dp.filter((item, index) => {
          dividen = this.calculate(idx).dividen()
          count = this.calculate(idx).count()

          fix = this.fixedNumber((this.form.total_price - dividen) / count)

          if (item.editable && index > idx) {
            item.price = fix
          }
        })

        this.calculate().totalDP()
      },
      calculate(idx) {
        let t = this
        return {
          dividenAdd() {
            let dividen = 0

            t.form.dp.filter((item, index) => {
              if (item.editable) {
                dividen += parseInt(item.price)
              }
            })

            return dividen
          },
          dividenRemove() {
            let dividen = 0
            
            t.form.dp.filter((item, index) => {
              if (!item.editable) {
                dividen += parseInt(item.price)
              }
            })

            return dividen
          },
          countRemove() {
            let count = 0
      
            t.form.dp.filter((item, index) => {
              if (item.editable) {
                count += 1
              }
            })

            return count
          },
          dividen() {
            let dividen = 0

            t.form.dp.filter((item, index) => {
              if (!item.editable || index <= idx) {
                dividen += parseInt(item.price)
              }
            })

            return dividen
          },
          count() {
            let count = 0
      
            t.form.dp.filter((item, index) => {
              if (item.editable && index > idx) {
                count += 1
              }
            })

            return count
          },
          totalDP() {
            return t.form.dp.reduce( ( sum, { price } ) => sum + parseInt(price) , 0)
          }
        }
      },
      fixedNumber(value) {
        return Number.parseFloat(value).toFixed(0)
      },
      async save() {
        this.error.message = ''
        this.process.run = true

        let forms = Object.assign({}, this.form)
        forms.delete = JSON.stringify(forms.delete)
        
        await post(`auth/transaction/cash-tempo/down-payment/create`, {
          data: forms
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.process.run = false
            this.fetch()
          } else {
            this.process.run = false
            this.error.message = res.msg
          }
        })
      },
      async confirmation() {
        this.error.message = ''
        this.process.form = true
        
        let form = {
          transaction_id: this.all ? this.$route.query.transaction : '',
          cash_tempo_id: this.all ? '' : this.detail.cash_tempo_id,
          paydate: '',
          desc: this.detail.cash_tempo_desc,
          status: this.user.user_company_roles_name.includes('superuser') || this.user.user_company_roles_name.includes('finance') ? 'close' : 'confirmed'
        }

        await post(`auth/transaction/cash-tempo/down-payment/update-payment`, {
          data: form
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.process.form = false
            this.dialog = false
            this.all = false
            this.detail = {}

            // window.open(res.data.url, '_blank')

            this.fetch()
          } else {
            this.process.form = false
            this.error.message = res.msg
          }
        })
      },
      async prints(id) {
        this.process.print = true

        let params = {
          cash_tempo_id: id
        }

        await get(`auth/transaction/cash-tempo/down-payment/print`, { params })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.print = false
            window.open(res.data.url, '_blank')
          }
          console.log('ini data res',res)
        })
      }
    }
  }
</script>